import type { ReactElement } from 'react'
import styled from 'styled-components'
import { Dialog, DialogProps } from '@material-ui/core'
import { H1 } from '@monthio/design-system'
import { PensionsinfoSuccess } from '@monthio/icons'
import { useTranslation } from 'react-i18next'

type PensionSuccessModalProps = Omit<DialogProps, 'children'>

const DialogBodyStyled = styled.div`
	text-align: center;
	background-color: white;
	padding: 20px 20px 10px;
	max-width: 400px;
`

export const PensionSuccessModal = (
	props: PensionSuccessModalProps,
): ReactElement => {
	const { t } = useTranslation()

	return (
		<Dialog {...props}>
			<DialogBodyStyled>
				<PensionsinfoSuccess width={250} />
				<H1>
					{t('pension-success-message')}
					<br />
					{t('pension-welcome-back')}
				</H1>
			</DialogBodyStyled>
		</Dialog>
	)
}
